const translations = {
  en: {
    app_name: "SplitBill",
    tagline: "Split the bill, not the friendship",
    subtitle: "No sign-up required. Create a group, add expenses, and let everyone know what they owe.",

    create_group: "Create Group",
    join_group: "Join a Group",
    join_group_desc: "Have a group link or ID? Enter it below.",
    enter_group_id: "Enter Group ID or paste link",
    join: "Join",
    creating: "Creating...",

    group_name: "Group Name",
    group_name_placeholder: "e.g. Bali Trip 2025",
    currency: "Currency",
    members: "members",
    add_member: "Add Member",
    add_another_member: "Add another member",
    member_name: "Name",

    features: "Features",
    feature_create_desc: "Create group & invite friends",
    feature_scan_desc: "AI bill scanning",
    feature_calculate_desc: "Auto-calculate balances",
    feature_share_desc: "Share link instantly",

    add_expense: "Add Expense",
    scan_bill: "Scan Bill",
    settle_up: "Settle Up",
    share_group: "Share",

    expenses: "Expenses",
    balances: "Balances",
    history: "History",
    bills: "Bills",
    no_bills: "No scanned bills yet.",
    item_breakdown: "Item Breakdown",

    total_expenses: "Total Expenses",
    total_expenses_lower: "total",
    per_person: "per person",

    description: "Description",
    expense_description_placeholder: "e.g. Dinner at Warung Babi",
    amount: "Amount",
    paid_by: "Paid By",
    split_among: "Split Among",
    date: "Date",
    people: "people",
    each: "each",

    scanned_from_bill: "Auto-filled from scanned bill",

    owes: "owes",
    owed: "is owed",
    settled: "Settled",
    all_settled: "All expenses are settled! Great job.",
    add_members_first: "Add members to start tracking expenses.",

    suggested_settlements: "Suggested Settlements",
    mark_as_paid: "Mark Paid",
    settlement_history: "Settlement History",
    settlement_recorded: "Payment recorded!",
    pays: "pays",
    paid: "paid",

    manual_settlement: "Record a manual payment",
    who_pays: "Who pays?",
    pays_to: "Pays to?",
    record_payment: "Record Payment",

    share_desc: "Anyone with this link can view and add expenses to this group.",
    copy_link: "Copy",
    link_copied: "Link copied to clipboard!",
    share_note: "This link gives full access — share only with your group members.",

    scan_bill_desc: "Take a photo of your receipt or upload an image file.",
    take_photo: "Take Photo",
    upload_file: "Upload File",
    scanning: "Scanning receipt...",
    scanning_desc: "AI is reading your bill",
    scan_error: "Could not read the bill. Please try a clearer image.",
    scan_error_balance: "Universal Key balance is insufficient. Go to Profile > Universal Key > Add Balance.",
    retake: "Retake",
    use_this_bill: "Use This Bill",
    total: "Total",
    assign_items: "Assign Items",
    item: "Item",
    payer: "Payer",
    assign_to: "Shared by",
    tax: "Tax",
    service_charge: "Service Charge",
    items_count: "items",
    select_payer: "Select payer",
    no_items: "No items detected. Enter total manually below.",

    save: "Save",
    saving: "Saving...",
    cancel: "Cancel",
    delete: "Delete",
    close: "Close",
    add: "Add",
    error: "Something went wrong. Please try again.",
    error_group_name: "Please enter a group name.",
    error_min_member: "Please add at least one member.",
    error_fill_required: "Please fill in all required fields.",
    expense_deleted: "Expense deleted",

    // New scan-first flow
    my_bill: "My Bill",
    scan_your_bill: "Scan Your Bill",
    scan_hero_subtitle: "Take a photo or upload a receipt to instantly split with friends.",
    enter_manually: "Enter amount manually",
    back_to_scan: "Back to scan",
    manual_amount: "Total Amount",
    manual_description: "Description (optional)",
    continue: "Continue",
    error_amount: "Please enter a valid amount.",
    error_min_people: "Please add at least 2 people.",
    whos_splitting: "Who's splitting?",
    add_person: "Add person",
    whos_paying: "Who paid?",
    person_name: "Person's name",
    calculate: "Calculate",
    split_results: "Split Results",
    each_person_pays: "each person pays",
    save_and_share: "Save & Share",
    split_again: "Split Again",
    or_join_group: "Or join an existing group",
    step_scan: "Scan",
    step_people: "People",
    step_assign: "Assign",
    step_results: "Results",
    assign_hint: "Tap who shared each item. Tax is split automatically.",
    unassigned: "Unassigned",

    no_expenses: "No expenses yet. Add your first one!",
    no_settlements: "No settlement history yet.",
    data_ttl_note: "Groups auto-delete after 24 hours.",
    rounding_note: "Rounding difference (pembulatan)",
    loading: "Loading...",
    group_not_found: "Group not found",
    group_not_found_desc: "This group doesn't exist or the link is incorrect.",
    back_to_home: "Back to Home",
  },
  id: {
    app_name: "SplitBill",
    tagline: "Bagi tagihan, bukan persahabatan",
    subtitle: "Tanpa perlu daftar. Buat grup, tambah pengeluaran, dan semua tahu berapa yang harus dibayar.",

    create_group: "Buat Grup",
    join_group: "Gabung Grup",
    join_group_desc: "Punya link atau ID grup? Masukkan di bawah.",
    enter_group_id: "Masukkan ID Grup atau tempel link",
    join: "Gabung",
    creating: "Membuat...",

    group_name: "Nama Grup",
    group_name_placeholder: "contoh: Liburan Bali 2025",
    currency: "Mata Uang",
    members: "anggota",
    add_member: "Tambah Anggota",
    add_another_member: "Tambah anggota lain",
    member_name: "Nama",

    features: "Fitur",
    feature_create_desc: "Buat grup & undang teman",
    feature_scan_desc: "Scan nota dengan AI",
    feature_calculate_desc: "Hitung saldo otomatis",
    feature_share_desc: "Bagikan link seketika",

    add_expense: "Tambah Pengeluaran",
    scan_bill: "Scan Nota",
    settle_up: "Lunasi",
    share_group: "Bagikan",

    expenses: "Pengeluaran",
    balances: "Saldo",
    history: "Riwayat",
    bills: "Nota",
    no_bills: "Belum ada nota scan.",
    item_breakdown: "Rincian Item",

    total_expenses: "Total Pengeluaran",
    total_expenses_lower: "total",
    per_person: "per orang",

    description: "Deskripsi",
    expense_description_placeholder: "contoh: Makan Malam di Warung",
    amount: "Jumlah",
    paid_by: "Dibayar Oleh",
    split_among: "Dibagi Ke",
    date: "Tanggal",
    people: "orang",
    each: "per orang",

    scanned_from_bill: "Terisi otomatis dari hasil scan",

    owes: "berhutang",
    owed: "dihutangi",
    settled: "Lunas",
    all_settled: "Semua pengeluaran sudah lunas! Kerja bagus.",
    add_members_first: "Tambah anggota untuk mulai mencatat pengeluaran.",

    suggested_settlements: "Saran Pelunasan",
    mark_as_paid: "Tandai Bayar",
    settlement_history: "Riwayat Pelunasan",
    settlement_recorded: "Pembayaran tercatat!",
    pays: "bayar ke",
    paid: "membayar",

    manual_settlement: "Catat pembayaran manual",
    who_pays: "Siapa yang bayar?",
    pays_to: "Bayar ke siapa?",
    record_payment: "Catat Pembayaran",

    share_desc: "Siapa saja dengan link ini bisa melihat dan menambah pengeluaran ke grup ini.",
    copy_link: "Salin",
    link_copied: "Link disalin ke clipboard!",
    share_note: "Link ini memberikan akses penuh — bagikan hanya ke anggota grupmu.",

    scan_bill_desc: "Ambil foto struk atau unggah gambar.",
    take_photo: "Ambil Foto",
    upload_file: "Unggah File",
    scanning: "Sedang memindai struk...",
    scanning_desc: "AI sedang membaca tagihan Anda",
    scan_error: "Tidak dapat membaca tagihan. Coba gambar yang lebih jelas.",
    scan_error_balance: "Saldo Universal Key tidak cukup. Pergi ke Profile > Universal Key > Add Balance.",
    retake: "Ambil Ulang",
    use_this_bill: "Gunakan Tagihan Ini",
    total: "Total",
    assign_items: "Bagikan Item",
    item: "Item",
    payer: "Pembayar",
    assign_to: "Dibagi oleh",
    tax: "Pajak",
    service_charge: "Biaya Layanan",
    items_count: "item",
    select_payer: "Pilih pembayar",
    no_items: "Tidak ada item terdeteksi. Masukkan total secara manual di bawah.",

    save: "Simpan",
    saving: "Menyimpan...",
    cancel: "Batal",
    delete: "Hapus",
    close: "Tutup",
    add: "Tambah",
    error: "Terjadi kesalahan. Coba lagi.",
    error_group_name: "Masukkan nama grup.",
    error_min_member: "Tambahkan minimal satu anggota.",
    error_fill_required: "Isi semua kolom yang diperlukan.",
    expense_deleted: "Pengeluaran dihapus",

    // New scan-first flow
    my_bill: "Tagihan Saya",
    scan_your_bill: "Pindai Tagihan",
    scan_hero_subtitle: "Ambil foto atau unggah gambar struk untuk langsung membagi tagihan.",
    enter_manually: "Masukkan manual",
    back_to_scan: "Kembali ke scan",
    manual_amount: "Total Tagihan",
    manual_description: "Keterangan (opsional)",
    continue: "Lanjut",
    error_amount: "Masukkan jumlah yang valid.",
    error_min_people: "Minimal 2 orang untuk membagi.",
    whos_splitting: "Siapa yang patungan?",
    add_person: "Tambah orang",
    whos_paying: "Siapa yang bayar?",
    person_name: "Nama",
    calculate: "Hitung",
    split_results: "Hasil Pembagian",
    each_person_pays: "per orang",
    save_and_share: "Simpan & Bagikan",
    split_again: "Hitung Lagi",
    or_join_group: "Atau gabung grup yang ada",
    step_scan: "Scan",
    step_people: "Orang",
    step_assign: "Bagi",
    step_results: "Hasil",
    assign_hint: "Pilih siapa yang ikut tiap item. Pajak dibagi otomatis.",
    unassigned: "Belum dibagi",

    no_expenses: "Belum ada pengeluaran. Tambah yang pertama!",
    no_settlements: "Belum ada riwayat pelunasan.",
    data_ttl_note: "Grup otomatis dihapus setelah 24 jam.",
    rounding_note: "Selisih pembulatan",
    loading: "Memuat...",
    group_not_found: "Grup tidak ditemukan",
    group_not_found_desc: "Grup ini tidak ada atau linknya salah.",
    back_to_home: "Kembali ke Beranda",
  }
};

export default translations;
